import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';

const baseUrl = new APISettings().getApiURL();

class FilingFormApi<FilingForm> extends BaseAPI {
  // constructor() {}

  public getFilingFormById: (id: number) => Promise<FilingForm> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/filingForm/${id}`)).data.output;
  }

  public getFilingForms: () => Promise<FilingForm> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/filingForm/`)).data.output;
  };

  public getFilingFormsByType: (id: number) => Promise<FilingForm> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/filingForm/getByFilingFormType/${id}`)).data.output;
  };
}

export const filingFormAPI = new FilingFormApi();
